import { render, staticRenderFns } from "./STable.vue?vue&type=template&id=1a097e06&scoped=true"
import script from "./STable.vue?vue&type=script&lang=js"
export * from "./STable.vue?vue&type=script&lang=js"
import style0 from "./STable.vue?vue&type=style&index=0&id=1a097e06&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a097e06",
  null
  
)

export default component.exports